import React from 'react';
import { Handshake, Truck, GraduationCap, LifeBuoy, Brain, ScanLine, HeartPulse, ShieldCheck } from 'lucide-react';
import { ABOUT } from '../data/mock';

const ICON_MAP = { Handshake, Truck, GraduationCap, LifeBuoy, Brain, ScanLine, HeartPulse, ShieldCheck };

export default function About() {
  return (
    <section id="about" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-20">
          <div className="lg:col-span-5">
            <span className="text-[12.5px] uppercase tracking-[0.22em] font-semibold text-[#E85A18]">
              {ABOUT.eyebrow}
            </span>
            <h2
              className="mt-3 text-[34px] sm:text-[42px] lg:text-[50px] leading-[1.05] tracking-[-0.025em] text-[#0F1B2D] font-semibold"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              {ABOUT.title}
            </h2>
            <p className="mt-6 text-[16px] leading-[1.75] text-slate-600 max-w-lg">{ABOUT.body}</p>

            <div className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-[#FFF6EE] border border-orange-100 px-5 py-4">
              <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#FFB27A] to-[#E85A18] flex items-center justify-center">
                <ShieldCheck className="h-5 w-5 text-white" />
              </div>
              <div>
                <div className="text-[13px] font-semibold text-[#0F1B2D]">Authorized India Partner</div>
                <div className="text-[12px] text-slate-500">RehabVeda R1 · Stroke Insightz</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {ABOUT.pillars.map((p, i) => {
              const Icon = ICON_MAP[p.icon] || Handshake;
              return (
                <div
                  key={p.title}
                  className="group relative rounded-2xl border border-slate-200/70 bg-white p-6 hover:border-orange-200 hover:bg-[#FFFBF6] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-25px_rgba(232,90,24,0.35)]"
                >
                  <div className="absolute top-6 right-6 text-[11px] font-mono text-slate-300">
                    0{i + 1}
                  </div>
                  <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#FFECD9] to-[#FFD5B4] flex items-center justify-center group-hover:from-[#FFB27A] group-hover:to-[#E85A18] transition-colors duration-300">
                    <Icon className="h-5 w-5 text-[#E85A18] group-hover:text-white transition-colors" />
                  </div>
                  <h3
                    className="mt-5 text-[19px] font-semibold text-[#0F1B2D]"
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    {p.title}
                  </h3>
                  <p className="mt-2 text-[14px] leading-[1.65] text-slate-600">{p.copy}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
